// extracted by mini-css-extract-plugin
export default {"collapsible-header":"Mix0iy9V","archived":"becBrIBp","elements":"VozALBK0","collapse-button":"r60rjbVi","expanded":"oovDG8KI"};